/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * myVault API
 * Secure document management platform with ISO 27001 compliance
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type {
  AppSchemasDocumentsDocumentStats,
  AuditTrailResponse,
  BulkCategorizeRequest,
  BulkCategorizeResponse,
  BulkDeleteRequest,
  BulkDeleteResponse,
  BulkDownloadRequest,
  BulkDownloadResponse,
  BulkMoveRequest,
  BulkMoveResponse,
  BulkShareRequest,
  BulkShareResponse,
  BulkTagsRequest,
  BulkTagsResponse,
  BulkUploadUrlRequest,
  BulkUploadUrlResponse,
  DocumentMetadataResponse,
  DocumentResponse,
  DocumentShareRequest,
  DocumentSharesListResponse,
  DocumentUpdate,
  DownloadUrlResponse,
  GetAuditTrailV1DocumentsDocumentIdAuditGetParams,
  HTTPValidationError,
  ListDocumentsV1DocumentsGetParams,
  PaginatedResponseDocumentListItem,
  PreviewUrlResponse,
  RedactionMetadataResponse,
  SummaryFeedbackRequest,
  SummaryFeedbackResponse,
  SummaryRegenerateRequest,
  SummaryRegenerateResponse,
  SummaryRequest,
  SummaryRequestResponse,
  SummaryResponse,
  UploadCompleteRequest,
  UploadCompleteResponse,
  UploadUrlRequest,
  UploadUrlResponse,
} from '../../schemas';
import { customFetch } from '../../http-client';

/**
 * Get paginated list of user's documents with optional filtering and sorting.
 * @summary List documents
 */
export const listDocumentsV1DocumentsGet = (
  params?: ListDocumentsV1DocumentsGetParams,
  signal?: AbortSignal
) => {
  return customFetch<PaginatedResponseDocumentListItem>({
    url: `/v1/documents`,
    method: 'GET',
    params,
    signal,
  });
};

export const getListDocumentsV1DocumentsGetQueryKey = (
  params?: ListDocumentsV1DocumentsGetParams
) => {
  return [`/v1/documents`, ...(params ? [params] : [])] as const;
};

export const getListDocumentsV1DocumentsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
  TError = HTTPValidationError,
>(
  params?: ListDocumentsV1DocumentsGetParams,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
    TError,
    TData
  >
) => {
  const queryKey = queryOptions?.queryKey ?? getListDocumentsV1DocumentsGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>> = ({
    signal,
  }) => listDocumentsV1DocumentsGet(params, signal);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDocumentsV1DocumentsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>
>;
export type ListDocumentsV1DocumentsGetQueryError = HTTPValidationError;

/**
 * @summary List documents
 */
export const useListDocumentsV1DocumentsGet = <
  TData = Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
  TError = HTTPValidationError,
>(
  params?: ListDocumentsV1DocumentsGetParams,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getListDocumentsV1DocumentsGetQueryOptions(params, queryOptions);

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getListDocumentsV1DocumentsGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
  TError = HTTPValidationError,
>(
  params?: ListDocumentsV1DocumentsGetParams,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
    TError,
    TData
  >
) => {
  const queryKey = queryOptions?.queryKey ?? getListDocumentsV1DocumentsGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>> = ({
    signal,
  }) => listDocumentsV1DocumentsGet(params, signal);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDocumentsV1DocumentsGetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>
>;
export type ListDocumentsV1DocumentsGetSuspenseQueryError = HTTPValidationError;

/**
 * @summary List documents
 */
export const useListDocumentsV1DocumentsGetSuspense = <
  TData = Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
  TError = HTTPValidationError,
>(
  params?: ListDocumentsV1DocumentsGetParams,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listDocumentsV1DocumentsGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getListDocumentsV1DocumentsGetSuspenseQueryOptions(params, queryOptions);

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Get aggregate statistics about user's documents.
 * @summary Get document statistics
 */
export const getDocumentStatsV1DocumentsStatsGet = (signal?: AbortSignal) => {
  return customFetch<AppSchemasDocumentsDocumentStats>({
    url: `/v1/documents/stats`,
    method: 'GET',
    signal,
  });
};

export const getGetDocumentStatsV1DocumentsStatsGetQueryKey = () => {
  return [`/v1/documents/stats`] as const;
};

export const getGetDocumentStatsV1DocumentsStatsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
  TError = unknown,
>(
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
    TError,
    TData
  >
) => {
  const queryKey = queryOptions?.queryKey ?? getGetDocumentStatsV1DocumentsStatsGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>> = ({
    signal,
  }) => getDocumentStatsV1DocumentsStatsGet(signal);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDocumentStatsV1DocumentsStatsGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>
>;
export type GetDocumentStatsV1DocumentsStatsGetQueryError = unknown;

/**
 * @summary Get document statistics
 */
export const useGetDocumentStatsV1DocumentsStatsGet = <
  TData = Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
  TError = unknown,
>(
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetDocumentStatsV1DocumentsStatsGetQueryOptions(queryOptions);

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getGetDocumentStatsV1DocumentsStatsGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
  TError = unknown,
>(
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
    TError,
    TData
  >
) => {
  const queryKey = queryOptions?.queryKey ?? getGetDocumentStatsV1DocumentsStatsGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>> = ({
    signal,
  }) => getDocumentStatsV1DocumentsStatsGet(signal);

  return { queryKey, queryFn, staleTime: 10000, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDocumentStatsV1DocumentsStatsGetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>
>;
export type GetDocumentStatsV1DocumentsStatsGetSuspenseQueryError = unknown;

/**
 * @summary Get document statistics
 */
export const useGetDocumentStatsV1DocumentsStatsGetSuspense = <
  TData = Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
  TError = unknown,
>(
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDocumentStatsV1DocumentsStatsGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetDocumentStatsV1DocumentsStatsGetSuspenseQueryOptions(queryOptions);

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Get document details and metadata by ID.
 * @summary Get document
 */
export const getDocumentV1DocumentsDocumentIdGet = (documentId: string, signal?: AbortSignal) => {
  return customFetch<DocumentResponse>({
    url: `/v1/documents/${documentId}`,
    method: 'GET',
    signal,
  });
};

export const getGetDocumentV1DocumentsDocumentIdGetQueryKey = (documentId: string) => {
  return [`/v1/documents/${documentId}`] as const;
};

export const getGetDocumentV1DocumentsDocumentIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ?? getGetDocumentV1DocumentsDocumentIdGetQueryKey(documentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>> = ({
    signal,
  }) => getDocumentV1DocumentsDocumentIdGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDocumentV1DocumentsDocumentIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>
>;
export type GetDocumentV1DocumentsDocumentIdGetQueryError = HTTPValidationError;

/**
 * @summary Get document
 */
export const useGetDocumentV1DocumentsDocumentIdGet = <
  TData = Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetDocumentV1DocumentsDocumentIdGetQueryOptions(documentId, queryOptions);

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getGetDocumentV1DocumentsDocumentIdGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ?? getGetDocumentV1DocumentsDocumentIdGetQueryKey(documentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>> = ({
    signal,
  }) => getDocumentV1DocumentsDocumentIdGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDocumentV1DocumentsDocumentIdGetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>
>;
export type GetDocumentV1DocumentsDocumentIdGetSuspenseQueryError = HTTPValidationError;

/**
 * @summary Get document
 */
export const useGetDocumentV1DocumentsDocumentIdGetSuspense = <
  TData = Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDocumentV1DocumentsDocumentIdGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetDocumentV1DocumentsDocumentIdGetSuspenseQueryOptions(
    documentId,
    queryOptions
  );

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Update document metadata.
 * @summary Update document
 */
export const updateDocumentV1DocumentsDocumentIdPatch = (
  documentId: string,
  documentUpdate: DocumentUpdate
) => {
  return customFetch<DocumentResponse>({
    url: `/v1/documents/${documentId}`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: documentUpdate,
  });
};

export const getUpdateDocumentV1DocumentsDocumentIdPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDocumentV1DocumentsDocumentIdPatch>>,
    TError,
    { documentId: string; data: DocumentUpdate },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof updateDocumentV1DocumentsDocumentIdPatch>>,
  TError,
  { documentId: string; data: DocumentUpdate },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateDocumentV1DocumentsDocumentIdPatch>>,
    { documentId: string; data: DocumentUpdate }
  > = (props) => {
    const { documentId, data } = props ?? {};

    return updateDocumentV1DocumentsDocumentIdPatch(documentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateDocumentV1DocumentsDocumentIdPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateDocumentV1DocumentsDocumentIdPatch>>
>;
export type UpdateDocumentV1DocumentsDocumentIdPatchMutationBody = DocumentUpdate;
export type UpdateDocumentV1DocumentsDocumentIdPatchMutationError = HTTPValidationError;

/**
 * @summary Update document
 */
export const useUpdateDocumentV1DocumentsDocumentIdPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof updateDocumentV1DocumentsDocumentIdPatch>>,
    TError,
    { documentId: string; data: DocumentUpdate },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof updateDocumentV1DocumentsDocumentIdPatch>>,
  TError,
  { documentId: string; data: DocumentUpdate },
  TContext
> => {
  const options = getUpdateDocumentV1DocumentsDocumentIdPatchMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Soft delete document (can be restored).
 * @summary Delete document
 */
export const deleteDocumentV1DocumentsDocumentIdDelete = (documentId: string) => {
  return customFetch<void>({ url: `/v1/documents/${documentId}`, method: 'DELETE' });
};

export const getDeleteDocumentV1DocumentsDocumentIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDocumentV1DocumentsDocumentIdDelete>>,
    TError,
    { documentId: string },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof deleteDocumentV1DocumentsDocumentIdDelete>>,
  TError,
  { documentId: string },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteDocumentV1DocumentsDocumentIdDelete>>,
    { documentId: string }
  > = (props) => {
    const { documentId } = props ?? {};

    return deleteDocumentV1DocumentsDocumentIdDelete(documentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteDocumentV1DocumentsDocumentIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteDocumentV1DocumentsDocumentIdDelete>>
>;

export type DeleteDocumentV1DocumentsDocumentIdDeleteMutationError = HTTPValidationError;

/**
 * @summary Delete document
 */
export const useDeleteDocumentV1DocumentsDocumentIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteDocumentV1DocumentsDocumentIdDelete>>,
    TError,
    { documentId: string },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof deleteDocumentV1DocumentsDocumentIdDelete>>,
  TError,
  { documentId: string },
  TContext
> => {
  const options = getDeleteDocumentV1DocumentsDocumentIdDeleteMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Get a presigned URL for direct upload to storage.
 * @summary Get presigned upload URL
 */
export const getUploadUrlV1DocumentsUploadUrlPost = (uploadUrlRequest: UploadUrlRequest) => {
  return customFetch<UploadUrlResponse>({
    url: `/v1/documents/upload-url`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: uploadUrlRequest,
  });
};

export const getGetUploadUrlV1DocumentsUploadUrlPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof getUploadUrlV1DocumentsUploadUrlPost>>,
    TError,
    { data: UploadUrlRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof getUploadUrlV1DocumentsUploadUrlPost>>,
  TError,
  { data: UploadUrlRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getUploadUrlV1DocumentsUploadUrlPost>>,
    { data: UploadUrlRequest }
  > = (props) => {
    const { data } = props ?? {};

    return getUploadUrlV1DocumentsUploadUrlPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GetUploadUrlV1DocumentsUploadUrlPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof getUploadUrlV1DocumentsUploadUrlPost>>
>;
export type GetUploadUrlV1DocumentsUploadUrlPostMutationBody = UploadUrlRequest;
export type GetUploadUrlV1DocumentsUploadUrlPostMutationError = HTTPValidationError;

/**
 * @summary Get presigned upload URL
 */
export const useGetUploadUrlV1DocumentsUploadUrlPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof getUploadUrlV1DocumentsUploadUrlPost>>,
    TError,
    { data: UploadUrlRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof getUploadUrlV1DocumentsUploadUrlPost>>,
  TError,
  { data: UploadUrlRequest },
  TContext
> => {
  const options = getGetUploadUrlV1DocumentsUploadUrlPostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Confirm that upload is complete and create document record.
 * @summary Confirm upload completion
 */
export const completeUploadV1DocumentsUploadCompletePost = (
  uploadCompleteRequest: UploadCompleteRequest
) => {
  return customFetch<UploadCompleteResponse>({
    url: `/v1/documents/upload-complete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: uploadCompleteRequest,
  });
};

export const getCompleteUploadV1DocumentsUploadCompletePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof completeUploadV1DocumentsUploadCompletePost>>,
    TError,
    { data: UploadCompleteRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof completeUploadV1DocumentsUploadCompletePost>>,
  TError,
  { data: UploadCompleteRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeUploadV1DocumentsUploadCompletePost>>,
    { data: UploadCompleteRequest }
  > = (props) => {
    const { data } = props ?? {};

    return completeUploadV1DocumentsUploadCompletePost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteUploadV1DocumentsUploadCompletePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeUploadV1DocumentsUploadCompletePost>>
>;
export type CompleteUploadV1DocumentsUploadCompletePostMutationBody = UploadCompleteRequest;
export type CompleteUploadV1DocumentsUploadCompletePostMutationError = HTTPValidationError;

/**
 * @summary Confirm upload completion
 */
export const useCompleteUploadV1DocumentsUploadCompletePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof completeUploadV1DocumentsUploadCompletePost>>,
    TError,
    { data: UploadCompleteRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof completeUploadV1DocumentsUploadCompletePost>>,
  TError,
  { data: UploadCompleteRequest },
  TContext
> => {
  const options = getCompleteUploadV1DocumentsUploadCompletePostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Get presigned download URL for document.
 * @summary Download document
 */
export const downloadDocumentV1DocumentsDocumentIdDownloadGet = (
  documentId: string,
  signal?: AbortSignal
) => {
  return customFetch<DownloadUrlResponse>({
    url: `/v1/documents/${documentId}/download`,
    method: 'GET',
    signal,
  });
};

export const getDownloadDocumentV1DocumentsDocumentIdDownloadGetQueryKey = (documentId: string) => {
  return [`/v1/documents/${documentId}/download`] as const;
};

export const getDownloadDocumentV1DocumentsDocumentIdDownloadGetQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ??
    getDownloadDocumentV1DocumentsDocumentIdDownloadGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>
  > = ({ signal }) => downloadDocumentV1DocumentsDocumentIdDownloadGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadDocumentV1DocumentsDocumentIdDownloadGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>
>;
export type DownloadDocumentV1DocumentsDocumentIdDownloadGetQueryError = HTTPValidationError;

/**
 * @summary Download document
 */
export const useDownloadDocumentV1DocumentsDocumentIdDownloadGet = <
  TData = Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getDownloadDocumentV1DocumentsDocumentIdDownloadGetQueryOptions(
    documentId,
    queryOptions
  );

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getDownloadDocumentV1DocumentsDocumentIdDownloadGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ??
    getDownloadDocumentV1DocumentsDocumentIdDownloadGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>
  > = ({ signal }) => downloadDocumentV1DocumentsDocumentIdDownloadGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type DownloadDocumentV1DocumentsDocumentIdDownloadGetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>
>;
export type DownloadDocumentV1DocumentsDocumentIdDownloadGetSuspenseQueryError =
  HTTPValidationError;

/**
 * @summary Download document
 */
export const useDownloadDocumentV1DocumentsDocumentIdDownloadGetSuspense = <
  TData = Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof downloadDocumentV1DocumentsDocumentIdDownloadGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getDownloadDocumentV1DocumentsDocumentIdDownloadGetSuspenseQueryOptions(
    documentId,
    queryOptions
  );

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Get presigned URL for previewing document in browser.
 * @summary Get preview URL
 */
export const getPreviewUrlV1DocumentsDocumentIdPreviewGet = (
  documentId: string,
  signal?: AbortSignal
) => {
  return customFetch<PreviewUrlResponse>({
    url: `/v1/documents/${documentId}/preview`,
    method: 'GET',
    signal,
  });
};

export const getGetPreviewUrlV1DocumentsDocumentIdPreviewGetQueryKey = (documentId: string) => {
  return [`/v1/documents/${documentId}/preview`] as const;
};

export const getGetPreviewUrlV1DocumentsDocumentIdPreviewGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ?? getGetPreviewUrlV1DocumentsDocumentIdPreviewGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>
  > = ({ signal }) => getPreviewUrlV1DocumentsDocumentIdPreviewGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPreviewUrlV1DocumentsDocumentIdPreviewGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>
>;
export type GetPreviewUrlV1DocumentsDocumentIdPreviewGetQueryError = HTTPValidationError;

/**
 * @summary Get preview URL
 */
export const useGetPreviewUrlV1DocumentsDocumentIdPreviewGet = <
  TData = Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetPreviewUrlV1DocumentsDocumentIdPreviewGetQueryOptions(
    documentId,
    queryOptions
  );

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getGetPreviewUrlV1DocumentsDocumentIdPreviewGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ?? getGetPreviewUrlV1DocumentsDocumentIdPreviewGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>
  > = ({ signal }) => getPreviewUrlV1DocumentsDocumentIdPreviewGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPreviewUrlV1DocumentsDocumentIdPreviewGetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>
>;
export type GetPreviewUrlV1DocumentsDocumentIdPreviewGetSuspenseQueryError = HTTPValidationError;

/**
 * @summary Get preview URL
 */
export const useGetPreviewUrlV1DocumentsDocumentIdPreviewGetSuspense = <
  TData = Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getPreviewUrlV1DocumentsDocumentIdPreviewGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetPreviewUrlV1DocumentsDocumentIdPreviewGetSuspenseQueryOptions(
    documentId,
    queryOptions
  );

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Get audit log entries for document.
 * @summary Get audit trail
 */
export const getAuditTrailV1DocumentsDocumentIdAuditGet = (
  documentId: string,
  params?: GetAuditTrailV1DocumentsDocumentIdAuditGetParams,
  signal?: AbortSignal
) => {
  return customFetch<AuditTrailResponse>({
    url: `/v1/documents/${documentId}/audit`,
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAuditTrailV1DocumentsDocumentIdAuditGetQueryKey = (
  documentId: string,
  params?: GetAuditTrailV1DocumentsDocumentIdAuditGetParams
) => {
  return [`/v1/documents/${documentId}/audit`, ...(params ? [params] : [])] as const;
};

export const getGetAuditTrailV1DocumentsDocumentIdAuditGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  params?: GetAuditTrailV1DocumentsDocumentIdAuditGetParams,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ??
    getGetAuditTrailV1DocumentsDocumentIdAuditGetQueryKey(documentId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>
  > = ({ signal }) => getAuditTrailV1DocumentsDocumentIdAuditGet(documentId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAuditTrailV1DocumentsDocumentIdAuditGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>
>;
export type GetAuditTrailV1DocumentsDocumentIdAuditGetQueryError = HTTPValidationError;

/**
 * @summary Get audit trail
 */
export const useGetAuditTrailV1DocumentsDocumentIdAuditGet = <
  TData = Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  params?: GetAuditTrailV1DocumentsDocumentIdAuditGetParams,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetAuditTrailV1DocumentsDocumentIdAuditGetQueryOptions(
    documentId,
    params,
    queryOptions
  );

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getGetAuditTrailV1DocumentsDocumentIdAuditGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  params?: GetAuditTrailV1DocumentsDocumentIdAuditGetParams,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ??
    getGetAuditTrailV1DocumentsDocumentIdAuditGetQueryKey(documentId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>
  > = ({ signal }) => getAuditTrailV1DocumentsDocumentIdAuditGet(documentId, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAuditTrailV1DocumentsDocumentIdAuditGetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>
>;
export type GetAuditTrailV1DocumentsDocumentIdAuditGetSuspenseQueryError = HTTPValidationError;

/**
 * @summary Get audit trail
 */
export const useGetAuditTrailV1DocumentsDocumentIdAuditGetSuspense = <
  TData = Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  params?: GetAuditTrailV1DocumentsDocumentIdAuditGetParams,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAuditTrailV1DocumentsDocumentIdAuditGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetAuditTrailV1DocumentsDocumentIdAuditGetSuspenseQueryOptions(
    documentId,
    params,
    queryOptions
  );

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Get AI-extracted metadata for document.
 * @summary Get AI metadata
 */
export const getDocumentMetadataV1DocumentsDocumentIdMetadataGet = (
  documentId: string,
  signal?: AbortSignal
) => {
  return customFetch<DocumentMetadataResponse>({
    url: `/v1/documents/${documentId}/metadata`,
    method: 'GET',
    signal,
  });
};

export const getGetDocumentMetadataV1DocumentsDocumentIdMetadataGetQueryKey = (
  documentId: string
) => {
  return [`/v1/documents/${documentId}/metadata`] as const;
};

export const getGetDocumentMetadataV1DocumentsDocumentIdMetadataGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ??
    getGetDocumentMetadataV1DocumentsDocumentIdMetadataGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>
  > = ({ signal }) => getDocumentMetadataV1DocumentsDocumentIdMetadataGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDocumentMetadataV1DocumentsDocumentIdMetadataGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>
>;
export type GetDocumentMetadataV1DocumentsDocumentIdMetadataGetQueryError = HTTPValidationError;

/**
 * @summary Get AI metadata
 */
export const useGetDocumentMetadataV1DocumentsDocumentIdMetadataGet = <
  TData = Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetDocumentMetadataV1DocumentsDocumentIdMetadataGetQueryOptions(
    documentId,
    queryOptions
  );

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getGetDocumentMetadataV1DocumentsDocumentIdMetadataGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ??
    getGetDocumentMetadataV1DocumentsDocumentIdMetadataGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>
  > = ({ signal }) => getDocumentMetadataV1DocumentsDocumentIdMetadataGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetDocumentMetadataV1DocumentsDocumentIdMetadataGetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>
>;
export type GetDocumentMetadataV1DocumentsDocumentIdMetadataGetSuspenseQueryError =
  HTTPValidationError;

/**
 * @summary Get AI metadata
 */
export const useGetDocumentMetadataV1DocumentsDocumentIdMetadataGetSuspense = <
  TData = Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getDocumentMetadataV1DocumentsDocumentIdMetadataGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetDocumentMetadataV1DocumentsDocumentIdMetadataGetSuspenseQueryOptions(
    documentId,
    queryOptions
  );

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Get redaction metadata for a document that was redacted before upload (BRD-014).
 * @summary Get redaction metadata
 */
export const getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet = (
  documentId: string,
  signal?: AbortSignal
) => {
  return customFetch<RedactionMetadataResponse>({
    url: `/v1/documents/${documentId}/redaction-metadata`,
    method: 'GET',
    signal,
  });
};

export const getGetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetQueryKey = (
  documentId: string
) => {
  return [`/v1/documents/${documentId}/redaction-metadata`] as const;
};

export const getGetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ??
    getGetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>
  > = ({ signal }) =>
    getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>
>;
export type GetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetQueryError =
  HTTPValidationError;

/**
 * @summary Get redaction metadata
 */
export const useGetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet = <
  TData = Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetQueryOptions(
    documentId,
    queryOptions
  );

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getGetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetSuspenseQueryOptions =
  <
    TData = Awaited<
      ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>
    >,
    TError = HTTPValidationError,
  >(
    documentId: string,
    queryOptions?: UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>,
      TError,
      TData
    >
  ) => {
    const queryKey =
      queryOptions?.queryKey ??
      getGetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetQueryKey(documentId);

    const queryFn: QueryFunction<
      Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>
    > = ({ signal }) =>
      getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet(documentId, signal);

    return {
      queryKey,
      queryFn,
      enabled: !!documentId,
      staleTime: 10000,
      ...queryOptions,
    } as UseSuspenseQueryOptions<
      Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>,
      TError,
      TData
    > & { queryKey: QueryKey };
  };

export type GetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetSuspenseQueryResult =
  NonNullable<
    Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>
  >;
export type GetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetSuspenseQueryError =
  HTTPValidationError;

/**
 * @summary Get redaction metadata
 */
export const useGetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetSuspense = <
  TData = Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options =
    getGetRedactionMetadataV1DocumentsDocumentIdRedactionMetadataGetSuspenseQueryOptions(
      documentId,
      queryOptions
    );

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Request AI-generated summary of document. Requires user consent.
 * @summary Request AI summary
 */
export const requestSummaryV1DocumentsDocumentIdSummarizePost = (
  documentId: string,
  summaryRequest: SummaryRequest
) => {
  return customFetch<SummaryRequestResponse>({
    url: `/v1/documents/${documentId}/summarize`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: summaryRequest,
  });
};

export const getRequestSummaryV1DocumentsDocumentIdSummarizePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof requestSummaryV1DocumentsDocumentIdSummarizePost>>,
    TError,
    { documentId: string; data: SummaryRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof requestSummaryV1DocumentsDocumentIdSummarizePost>>,
  TError,
  { documentId: string; data: SummaryRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof requestSummaryV1DocumentsDocumentIdSummarizePost>>,
    { documentId: string; data: SummaryRequest }
  > = (props) => {
    const { documentId, data } = props ?? {};

    return requestSummaryV1DocumentsDocumentIdSummarizePost(documentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RequestSummaryV1DocumentsDocumentIdSummarizePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof requestSummaryV1DocumentsDocumentIdSummarizePost>>
>;
export type RequestSummaryV1DocumentsDocumentIdSummarizePostMutationBody = SummaryRequest;
export type RequestSummaryV1DocumentsDocumentIdSummarizePostMutationError = HTTPValidationError;

/**
 * @summary Request AI summary
 */
export const useRequestSummaryV1DocumentsDocumentIdSummarizePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof requestSummaryV1DocumentsDocumentIdSummarizePost>>,
    TError,
    { documentId: string; data: SummaryRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof requestSummaryV1DocumentsDocumentIdSummarizePost>>,
  TError,
  { documentId: string; data: SummaryRequest },
  TContext
> => {
  const options =
    getRequestSummaryV1DocumentsDocumentIdSummarizePostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Get the AI-generated summary for a document.
 * @summary Get AI summary
 */
export const getSummaryV1DocumentsDocumentIdSummaryGet = (
  documentId: string,
  signal?: AbortSignal
) => {
  return customFetch<SummaryResponse>({
    url: `/v1/documents/${documentId}/summary`,
    method: 'GET',
    signal,
  });
};

export const getGetSummaryV1DocumentsDocumentIdSummaryGetQueryKey = (documentId: string) => {
  return [`/v1/documents/${documentId}/summary`] as const;
};

export const getGetSummaryV1DocumentsDocumentIdSummaryGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ?? getGetSummaryV1DocumentsDocumentIdSummaryGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>
  > = ({ signal }) => getSummaryV1DocumentsDocumentIdSummaryGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSummaryV1DocumentsDocumentIdSummaryGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>
>;
export type GetSummaryV1DocumentsDocumentIdSummaryGetQueryError = HTTPValidationError;

/**
 * @summary Get AI summary
 */
export const useGetSummaryV1DocumentsDocumentIdSummaryGet = <
  TData = Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetSummaryV1DocumentsDocumentIdSummaryGetQueryOptions(
    documentId,
    queryOptions
  );

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getGetSummaryV1DocumentsDocumentIdSummaryGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ?? getGetSummaryV1DocumentsDocumentIdSummaryGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>
  > = ({ signal }) => getSummaryV1DocumentsDocumentIdSummaryGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetSummaryV1DocumentsDocumentIdSummaryGetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>
>;
export type GetSummaryV1DocumentsDocumentIdSummaryGetSuspenseQueryError = HTTPValidationError;

/**
 * @summary Get AI summary
 */
export const useGetSummaryV1DocumentsDocumentIdSummaryGetSuspense = <
  TData = Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getSummaryV1DocumentsDocumentIdSummaryGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getGetSummaryV1DocumentsDocumentIdSummaryGetSuspenseQueryOptions(
    documentId,
    queryOptions
  );

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Regenerate the AI summary with optional new parameters.
 * @summary Regenerate AI summary
 */
export const regenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePost = (
  documentId: string,
  summaryRegenerateRequest: SummaryRegenerateRequest
) => {
  return customFetch<SummaryRegenerateResponse>({
    url: `/v1/documents/${documentId}/summary/regenerate`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: summaryRegenerateRequest,
  });
};

export const getRegenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePost>>,
    TError,
    { documentId: string; data: SummaryRegenerateRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePost>>,
  TError,
  { documentId: string; data: SummaryRegenerateRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePost>>,
    { documentId: string; data: SummaryRegenerateRequest }
  > = (props) => {
    const { documentId, data } = props ?? {};

    return regenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePost(documentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePost>>
>;
export type RegenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePostMutationBody =
  SummaryRegenerateRequest;
export type RegenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePostMutationError =
  HTTPValidationError;

/**
 * @summary Regenerate AI summary
 */
export const useRegenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePost>>,
    TError,
    { documentId: string; data: SummaryRegenerateRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof regenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePost>>,
  TError,
  { documentId: string; data: SummaryRegenerateRequest },
  TContext
> => {
  const options =
    getRegenerateSummaryV1DocumentsDocumentIdSummaryRegeneratePostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Provide feedback on the AI summary quality.
 * @summary Submit summary feedback
 */
export const submitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPost = (
  documentId: string,
  summaryFeedbackRequest: SummaryFeedbackRequest
) => {
  return customFetch<SummaryFeedbackResponse>({
    url: `/v1/documents/${documentId}/summary/feedback`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: summaryFeedbackRequest,
  });
};

export const getSubmitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof submitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPost>>,
    TError,
    { documentId: string; data: SummaryFeedbackRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof submitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPost>>,
  TError,
  { documentId: string; data: SummaryFeedbackRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof submitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPost>>,
    { documentId: string; data: SummaryFeedbackRequest }
  > = (props) => {
    const { documentId, data } = props ?? {};

    return submitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPost(documentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type SubmitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPostMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof submitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPost>>
  >;
export type SubmitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPostMutationBody =
  SummaryFeedbackRequest;
export type SubmitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPostMutationError =
  HTTPValidationError;

/**
 * @summary Submit summary feedback
 */
export const useSubmitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof submitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPost>>,
    TError,
    { documentId: string; data: SummaryFeedbackRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof submitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPost>>,
  TError,
  { documentId: string; data: SummaryFeedbackRequest },
  TContext
> => {
  const options =
    getSubmitSummaryFeedbackV1DocumentsDocumentIdSummaryFeedbackPostMutationOptions(
      mutationOptions
    );

  return useMutation(options);
};
/**
 * Share document with one or more users.
 * @summary Share document
 */
export const shareDocumentV1DocumentsDocumentIdSharePost = (
  documentId: string,
  documentShareRequest: DocumentShareRequest
) => {
  return customFetch<DocumentSharesListResponse>({
    url: `/v1/documents/${documentId}/share`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: documentShareRequest,
  });
};

export const getShareDocumentV1DocumentsDocumentIdSharePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof shareDocumentV1DocumentsDocumentIdSharePost>>,
    TError,
    { documentId: string; data: DocumentShareRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof shareDocumentV1DocumentsDocumentIdSharePost>>,
  TError,
  { documentId: string; data: DocumentShareRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shareDocumentV1DocumentsDocumentIdSharePost>>,
    { documentId: string; data: DocumentShareRequest }
  > = (props) => {
    const { documentId, data } = props ?? {};

    return shareDocumentV1DocumentsDocumentIdSharePost(documentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShareDocumentV1DocumentsDocumentIdSharePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof shareDocumentV1DocumentsDocumentIdSharePost>>
>;
export type ShareDocumentV1DocumentsDocumentIdSharePostMutationBody = DocumentShareRequest;
export type ShareDocumentV1DocumentsDocumentIdSharePostMutationError = HTTPValidationError;

/**
 * @summary Share document
 */
export const useShareDocumentV1DocumentsDocumentIdSharePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof shareDocumentV1DocumentsDocumentIdSharePost>>,
    TError,
    { documentId: string; data: DocumentShareRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof shareDocumentV1DocumentsDocumentIdSharePost>>,
  TError,
  { documentId: string; data: DocumentShareRequest },
  TContext
> => {
  const options = getShareDocumentV1DocumentsDocumentIdSharePostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Get list of users this document is shared with.
 * @summary List document shares
 */
export const listDocumentSharesV1DocumentsDocumentIdSharesGet = (
  documentId: string,
  signal?: AbortSignal
) => {
  return customFetch<DocumentSharesListResponse>({
    url: `/v1/documents/${documentId}/shares`,
    method: 'GET',
    signal,
  });
};

export const getListDocumentSharesV1DocumentsDocumentIdSharesGetQueryKey = (documentId: string) => {
  return [`/v1/documents/${documentId}/shares`] as const;
};

export const getListDocumentSharesV1DocumentsDocumentIdSharesGetQueryOptions = <
  TData = Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ??
    getListDocumentSharesV1DocumentsDocumentIdSharesGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>
  > = ({ signal }) => listDocumentSharesV1DocumentsDocumentIdSharesGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDocumentSharesV1DocumentsDocumentIdSharesGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>
>;
export type ListDocumentSharesV1DocumentsDocumentIdSharesGetQueryError = HTTPValidationError;

/**
 * @summary List document shares
 */
export const useListDocumentSharesV1DocumentsDocumentIdSharesGet = <
  TData = Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseQueryOptions<
    Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
    TError,
    TData
  >
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getListDocumentSharesV1DocumentsDocumentIdSharesGetQueryOptions(
    documentId,
    queryOptions
  );

  const query = useQuery(options) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = options.queryKey;

  return query;
};

export const getListDocumentSharesV1DocumentsDocumentIdSharesGetSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
    TError,
    TData
  >
) => {
  const queryKey =
    queryOptions?.queryKey ??
    getListDocumentSharesV1DocumentsDocumentIdSharesGetQueryKey(documentId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>
  > = ({ signal }) => listDocumentSharesV1DocumentsDocumentIdSharesGet(documentId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!documentId,
    staleTime: 10000,
    ...queryOptions,
  } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListDocumentSharesV1DocumentsDocumentIdSharesGetSuspenseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>
>;
export type ListDocumentSharesV1DocumentsDocumentIdSharesGetSuspenseQueryError =
  HTTPValidationError;

/**
 * @summary List document shares
 */
export const useListDocumentSharesV1DocumentsDocumentIdSharesGetSuspense = <
  TData = Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
  TError = HTTPValidationError,
>(
  documentId: string,
  queryOptions?: UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof listDocumentSharesV1DocumentsDocumentIdSharesGet>>,
    TError,
    TData
  >
): UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const options = getListDocumentSharesV1DocumentsDocumentIdSharesGetSuspenseQueryOptions(
    documentId,
    queryOptions
  );

  const query = useSuspenseQuery(options) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = options.queryKey;

  return query;
};

/**
 * Revoke access for a specific user.
 * @summary Revoke document share
 */
export const unshareDocumentV1DocumentsDocumentIdShareShareUserIdDelete = (
  documentId: string,
  shareUserId: string
) => {
  return customFetch<void>({
    url: `/v1/documents/${documentId}/share/${shareUserId}`,
    method: 'DELETE',
  });
};

export const getUnshareDocumentV1DocumentsDocumentIdShareShareUserIdDeleteMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof unshareDocumentV1DocumentsDocumentIdShareShareUserIdDelete>>,
    TError,
    { documentId: string; shareUserId: string },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof unshareDocumentV1DocumentsDocumentIdShareShareUserIdDelete>>,
  TError,
  { documentId: string; shareUserId: string },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof unshareDocumentV1DocumentsDocumentIdShareShareUserIdDelete>>,
    { documentId: string; shareUserId: string }
  > = (props) => {
    const { documentId, shareUserId } = props ?? {};

    return unshareDocumentV1DocumentsDocumentIdShareShareUserIdDelete(documentId, shareUserId);
  };

  return { mutationFn, ...mutationOptions };
};

export type UnshareDocumentV1DocumentsDocumentIdShareShareUserIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof unshareDocumentV1DocumentsDocumentIdShareShareUserIdDelete>>
>;

export type UnshareDocumentV1DocumentsDocumentIdShareShareUserIdDeleteMutationError =
  HTTPValidationError;

/**
 * @summary Revoke document share
 */
export const useUnshareDocumentV1DocumentsDocumentIdShareShareUserIdDelete = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof unshareDocumentV1DocumentsDocumentIdShareShareUserIdDelete>>,
    TError,
    { documentId: string; shareUserId: string },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof unshareDocumentV1DocumentsDocumentIdShareShareUserIdDelete>>,
  TError,
  { documentId: string; shareUserId: string },
  TContext
> => {
  const options =
    getUnshareDocumentV1DocumentsDocumentIdShareShareUserIdDeleteMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Soft delete multiple documents at once (max 100).
 * @summary Bulk delete documents
 */
export const bulkDeleteDocumentsV1DocumentsBulkDeletePost = (
  bulkDeleteRequest: BulkDeleteRequest
) => {
  return customFetch<BulkDeleteResponse>({
    url: `/v1/documents/bulk/delete`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkDeleteRequest,
  });
};

export const getBulkDeleteDocumentsV1DocumentsBulkDeletePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteDocumentsV1DocumentsBulkDeletePost>>,
    TError,
    { data: BulkDeleteRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDeleteDocumentsV1DocumentsBulkDeletePost>>,
  TError,
  { data: BulkDeleteRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDeleteDocumentsV1DocumentsBulkDeletePost>>,
    { data: BulkDeleteRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkDeleteDocumentsV1DocumentsBulkDeletePost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDeleteDocumentsV1DocumentsBulkDeletePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDeleteDocumentsV1DocumentsBulkDeletePost>>
>;
export type BulkDeleteDocumentsV1DocumentsBulkDeletePostMutationBody = BulkDeleteRequest;
export type BulkDeleteDocumentsV1DocumentsBulkDeletePostMutationError = HTTPValidationError;

/**
 * @summary Bulk delete documents
 */
export const useBulkDeleteDocumentsV1DocumentsBulkDeletePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDeleteDocumentsV1DocumentsBulkDeletePost>>,
    TError,
    { data: BulkDeleteRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof bulkDeleteDocumentsV1DocumentsBulkDeletePost>>,
  TError,
  { data: BulkDeleteRequest },
  TContext
> => {
  const options = getBulkDeleteDocumentsV1DocumentsBulkDeletePostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Move multiple documents to a category at once (max 100).
 * @summary Bulk categorize documents
 */
export const bulkCategorizeDocumentsV1DocumentsBulkCategorizePost = (
  bulkCategorizeRequest: BulkCategorizeRequest
) => {
  return customFetch<BulkCategorizeResponse>({
    url: `/v1/documents/bulk/categorize`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkCategorizeRequest,
  });
};

export const getBulkCategorizeDocumentsV1DocumentsBulkCategorizePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkCategorizeDocumentsV1DocumentsBulkCategorizePost>>,
    TError,
    { data: BulkCategorizeRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof bulkCategorizeDocumentsV1DocumentsBulkCategorizePost>>,
  TError,
  { data: BulkCategorizeRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkCategorizeDocumentsV1DocumentsBulkCategorizePost>>,
    { data: BulkCategorizeRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkCategorizeDocumentsV1DocumentsBulkCategorizePost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkCategorizeDocumentsV1DocumentsBulkCategorizePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkCategorizeDocumentsV1DocumentsBulkCategorizePost>>
>;
export type BulkCategorizeDocumentsV1DocumentsBulkCategorizePostMutationBody =
  BulkCategorizeRequest;
export type BulkCategorizeDocumentsV1DocumentsBulkCategorizePostMutationError = HTTPValidationError;

/**
 * @summary Bulk categorize documents
 */
export const useBulkCategorizeDocumentsV1DocumentsBulkCategorizePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkCategorizeDocumentsV1DocumentsBulkCategorizePost>>,
    TError,
    { data: BulkCategorizeRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof bulkCategorizeDocumentsV1DocumentsBulkCategorizePost>>,
  TError,
  { data: BulkCategorizeRequest },
  TContext
> => {
  const options =
    getBulkCategorizeDocumentsV1DocumentsBulkCategorizePostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Move multiple documents to a folder at once (max 100).
 * @summary Bulk move documents
 */
export const bulkMoveDocumentsV1DocumentsBulkMovePost = (bulkMoveRequest: BulkMoveRequest) => {
  return customFetch<BulkMoveResponse>({
    url: `/v1/documents/bulk/move`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkMoveRequest,
  });
};

export const getBulkMoveDocumentsV1DocumentsBulkMovePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkMoveDocumentsV1DocumentsBulkMovePost>>,
    TError,
    { data: BulkMoveRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof bulkMoveDocumentsV1DocumentsBulkMovePost>>,
  TError,
  { data: BulkMoveRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkMoveDocumentsV1DocumentsBulkMovePost>>,
    { data: BulkMoveRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkMoveDocumentsV1DocumentsBulkMovePost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkMoveDocumentsV1DocumentsBulkMovePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkMoveDocumentsV1DocumentsBulkMovePost>>
>;
export type BulkMoveDocumentsV1DocumentsBulkMovePostMutationBody = BulkMoveRequest;
export type BulkMoveDocumentsV1DocumentsBulkMovePostMutationError = HTTPValidationError;

/**
 * @summary Bulk move documents
 */
export const useBulkMoveDocumentsV1DocumentsBulkMovePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkMoveDocumentsV1DocumentsBulkMovePost>>,
    TError,
    { data: BulkMoveRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof bulkMoveDocumentsV1DocumentsBulkMovePost>>,
  TError,
  { data: BulkMoveRequest },
  TContext
> => {
  const options = getBulkMoveDocumentsV1DocumentsBulkMovePostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Download multiple documents as a ZIP file (max 50, 100MB total).
 * @summary Bulk download documents
 */
export const bulkDownloadDocumentsV1DocumentsBulkDownloadPost = (
  bulkDownloadRequest: BulkDownloadRequest
) => {
  return customFetch<BulkDownloadResponse>({
    url: `/v1/documents/bulk/download`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkDownloadRequest,
  });
};

export const getBulkDownloadDocumentsV1DocumentsBulkDownloadPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDownloadDocumentsV1DocumentsBulkDownloadPost>>,
    TError,
    { data: BulkDownloadRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof bulkDownloadDocumentsV1DocumentsBulkDownloadPost>>,
  TError,
  { data: BulkDownloadRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkDownloadDocumentsV1DocumentsBulkDownloadPost>>,
    { data: BulkDownloadRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkDownloadDocumentsV1DocumentsBulkDownloadPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkDownloadDocumentsV1DocumentsBulkDownloadPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkDownloadDocumentsV1DocumentsBulkDownloadPost>>
>;
export type BulkDownloadDocumentsV1DocumentsBulkDownloadPostMutationBody = BulkDownloadRequest;
export type BulkDownloadDocumentsV1DocumentsBulkDownloadPostMutationError = HTTPValidationError;

/**
 * @summary Bulk download documents
 */
export const useBulkDownloadDocumentsV1DocumentsBulkDownloadPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkDownloadDocumentsV1DocumentsBulkDownloadPost>>,
    TError,
    { data: BulkDownloadRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof bulkDownloadDocumentsV1DocumentsBulkDownloadPost>>,
  TError,
  { data: BulkDownloadRequest },
  TContext
> => {
  const options =
    getBulkDownloadDocumentsV1DocumentsBulkDownloadPostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Get presigned URLs for uploading multiple documents (max 20).
 * @summary Get bulk upload URLs
 */
export const bulkUploadUrlsV1DocumentsBulkUploadPost = (
  bulkUploadUrlRequest: BulkUploadUrlRequest
) => {
  return customFetch<BulkUploadUrlResponse>({
    url: `/v1/documents/bulk-upload`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkUploadUrlRequest,
  });
};

export const getBulkUploadUrlsV1DocumentsBulkUploadPostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUploadUrlsV1DocumentsBulkUploadPost>>,
    TError,
    { data: BulkUploadUrlRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUploadUrlsV1DocumentsBulkUploadPost>>,
  TError,
  { data: BulkUploadUrlRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUploadUrlsV1DocumentsBulkUploadPost>>,
    { data: BulkUploadUrlRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkUploadUrlsV1DocumentsBulkUploadPost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUploadUrlsV1DocumentsBulkUploadPostMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUploadUrlsV1DocumentsBulkUploadPost>>
>;
export type BulkUploadUrlsV1DocumentsBulkUploadPostMutationBody = BulkUploadUrlRequest;
export type BulkUploadUrlsV1DocumentsBulkUploadPostMutationError = HTTPValidationError;

/**
 * @summary Get bulk upload URLs
 */
export const useBulkUploadUrlsV1DocumentsBulkUploadPost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUploadUrlsV1DocumentsBulkUploadPost>>,
    TError,
    { data: BulkUploadUrlRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof bulkUploadUrlsV1DocumentsBulkUploadPost>>,
  TError,
  { data: BulkUploadUrlRequest },
  TContext
> => {
  const options = getBulkUploadUrlsV1DocumentsBulkUploadPostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Share multiple documents with multiple users at once.
 * @summary Bulk share documents
 */
export const bulkShareDocumentsV1DocumentsBulkSharePost = (bulkShareRequest: BulkShareRequest) => {
  return customFetch<BulkShareResponse>({
    url: `/v1/documents/bulk-share`,
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    data: bulkShareRequest,
  });
};

export const getBulkShareDocumentsV1DocumentsBulkSharePostMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkShareDocumentsV1DocumentsBulkSharePost>>,
    TError,
    { data: BulkShareRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof bulkShareDocumentsV1DocumentsBulkSharePost>>,
  TError,
  { data: BulkShareRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkShareDocumentsV1DocumentsBulkSharePost>>,
    { data: BulkShareRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkShareDocumentsV1DocumentsBulkSharePost(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkShareDocumentsV1DocumentsBulkSharePostMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkShareDocumentsV1DocumentsBulkSharePost>>
>;
export type BulkShareDocumentsV1DocumentsBulkSharePostMutationBody = BulkShareRequest;
export type BulkShareDocumentsV1DocumentsBulkSharePostMutationError = HTTPValidationError;

/**
 * @summary Bulk share documents
 */
export const useBulkShareDocumentsV1DocumentsBulkSharePost = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkShareDocumentsV1DocumentsBulkSharePost>>,
    TError,
    { data: BulkShareRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof bulkShareDocumentsV1DocumentsBulkSharePost>>,
  TError,
  { data: BulkShareRequest },
  TContext
> => {
  const options = getBulkShareDocumentsV1DocumentsBulkSharePostMutationOptions(mutationOptions);

  return useMutation(options);
};
/**
 * Add or remove tags on multiple documents at once.
 * @summary Bulk update tags
 */
export const bulkUpdateTagsV1DocumentsBulkTagsPatch = (bulkTagsRequest: BulkTagsRequest) => {
  return customFetch<BulkTagsResponse>({
    url: `/v1/documents/bulk-tags`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: bulkTagsRequest,
  });
};

export const getBulkUpdateTagsV1DocumentsBulkTagsPatchMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateTagsV1DocumentsBulkTagsPatch>>,
    TError,
    { data: BulkTagsRequest },
    TContext
  >
): UseMutationOptions<
  Awaited<ReturnType<typeof bulkUpdateTagsV1DocumentsBulkTagsPatch>>,
  TError,
  { data: BulkTagsRequest },
  TContext
> => {
  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof bulkUpdateTagsV1DocumentsBulkTagsPatch>>,
    { data: BulkTagsRequest }
  > = (props) => {
    const { data } = props ?? {};

    return bulkUpdateTagsV1DocumentsBulkTagsPatch(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BulkUpdateTagsV1DocumentsBulkTagsPatchMutationResult = NonNullable<
  Awaited<ReturnType<typeof bulkUpdateTagsV1DocumentsBulkTagsPatch>>
>;
export type BulkUpdateTagsV1DocumentsBulkTagsPatchMutationBody = BulkTagsRequest;
export type BulkUpdateTagsV1DocumentsBulkTagsPatchMutationError = HTTPValidationError;

/**
 * @summary Bulk update tags
 */
export const useBulkUpdateTagsV1DocumentsBulkTagsPatch = <
  TError = HTTPValidationError,
  TContext = unknown,
>(
  mutationOptions?: UseMutationOptions<
    Awaited<ReturnType<typeof bulkUpdateTagsV1DocumentsBulkTagsPatch>>,
    TError,
    { data: BulkTagsRequest },
    TContext
  >
): UseMutationResult<
  Awaited<ReturnType<typeof bulkUpdateTagsV1DocumentsBulkTagsPatch>>,
  TError,
  { data: BulkTagsRequest },
  TContext
> => {
  const options = getBulkUpdateTagsV1DocumentsBulkTagsPatchMutationOptions(mutationOptions);

  return useMutation(options);
};
